import React from "react";
import "./RackHeightsSheet.scss";
import { getSessionOptions } from "util/options";
import { getBenchLabel } from "util/meetHelper";
import { useMeet } from "util/useMeet";
import sortBy from "lodash/sortBy";
import map from "lodash/map";
import filter from "lodash/filter";
import size from "lodash/size";

const RackHeightsSheet = () => {
  const meet = useMeet();
  const lifters = sortBy(meet.lifters, ["name"]);

  return (
    <div className="rack-heights-sheet">
      {map(getSessionOptions(), (session) => {
        const sessionLifters = filter(lifters, { session: session.value });
        const sessionCount = size(sessionLifters);
        if (!sessionCount) {
          return null;
        }

        return (
          <div key={session.value} className="session-pages">
            <div className="meet-name">
              {meet.date} - {meet.name} - Session {session.value} - RACK HEIGHTS
            </div>
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Squat Rack</th>
                  <th>Squat In/Out</th>
                  <th>{getBenchLabel(meet)} Rack</th>
                  {meet.federation !== "USSF" && <th>Bench Saftey</th>}
                  {meet.federation !== "USSF" && <th>Bench Foot Blocks</th>}
                  <th>Lifter/Coach Signature</th>
                </tr>
              </thead>
              <tbody>
                {map(sessionLifters, (lifter) => {
                  return (
                    <tr key={lifter._id}>
                      <td>{lifter.name}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      {meet.federation !== "USSF" && <td></td>}
                      {meet.federation !== "USSF" && <td></td>}
                      <td></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        );
      })}
    </div>
  );
};

export default RackHeightsSheet;
